import { jsx as _jsx } from "react/jsx-runtime";
import { WithTooltip } from './WithTooltip';
export function TextRenderer(param) {
    let { value, styleBold } = param;
    return /*#__PURE__*/ _jsx(WithTooltip, {
        name: value,
        styleBold: styleBold
    });
}
